export const checkOnboarding = () => {
  //localStorage.setItem('onboardingDone', 'false');
  const done = localStorage.getItem('onboardingDone');
  if (done === 'true') {
    return false;
  } else {
    return true;
  }
};

export const setOnboardingDone = () => {
  localStorage.setItem('onboardingDone', 'true');
};

export const resetOnboarding = () => {
  localStorage.setItem('onboardingDone', 'false');
};
